export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'
export const START_UPDATING = 'START_UPDATING'
export const STOP_UPDATING = 'STOP_UPDATING'
export const ADD_CARD = 'ADD_CARD'
export const UPDATE_CARD = 'UPDATE_CARD'
export const ADD_DRAFT_PRICE = 'ADD_DRAFT_PRICE'
export const REMOVE_DRAFT_PRICE = 'REMOVE_DRAFT_PRICE'
export const RECORD_CHANGED = 'RECORD_CHANGED'
export const SET_PREVIOUS_PRICES = 'SET_PREVIOUS_PRICES'



// WEBPACK FOOTER //
// ./src/mutation-types.js